// eventService.js

import axios from 'axios';
import { URL } from "../config";
const BASE_URL = URL;

const eventService = {
  createEvent: async (eventData) => {
    try {
      const response = await axios.post(`${BASE_URL}/events/`, eventData);
      return response.data;
    } catch (error) {
      throw new Error(`Error creating event: ${error.message}`);
    }
  },

  deleteEvent: async (eventId) => {
    try {
      const response = await axios.delete(`${BASE_URL}/events/${eventId}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error deleting event: ${error.message}`);
    }
  },

  updateEvent: async (eventId, updateData) => {
    try {
      const response = await axios.put(`${BASE_URL}/events/${eventId}`, updateData);
      return response.data;
    } catch (error) {
      throw new Error(`Error updating event: ${error.message}`);
    }
  },

  getEventById: async (eventId) => {
    try {
      const response = await axios.get(`${BASE_URL}/events/${eventId}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error getting event: ${error.message}`);
    }
  },

  getEventsList: async (semesterId, options = {}) => {
    try {
      const params = { ...(semesterId ? { semester: semesterId } : {}), ...options };
      const response = await axios.get(`${BASE_URL}/events/list`, { params });
      return response.data;
    } catch (error) {
      throw new Error(`Error getting events list: ${error.message}`);
    }
  },

  // options: { semester, includeGeneralMeetings, onlyGeneralMeetings }
  getEventsByUser: async (userId, options = {}) => {
    try {
      const response = await axios.get(`${BASE_URL}/events/eventsbyuser/${userId}`, { params: options });
      return response.data;
    } catch (error) {
      throw new Error(`Error getting events by user: ${error.message}`);
    }
  },

  addParticipants: async (eventId, participants) => {
    try {
      const response = await axios.put(`${BASE_URL}/events/${eventId}/addParticipants`, { participants });
      return response.data;
    } catch (error) {
      throw new Error(`Error adding participants to event: ${error.message}`);
    }
  },

};

export default eventService;
